export default __webpack_public_path__ + "static/media/image-rules-bonus.513320fb.svg";